exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-add-new {\n  float: right;\n  display: inline-block;\n  height: 29px;\n  line-height: 9px;\n  margin-left: 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/main/pages/organization-list/organization-list.component.css
// module id = ../../../../../src/app/main/pages/organization-list/organization-list.component.css
// module chunks = main